module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAgCAYAAAASYli2AAAA2klEQVR42mJg+P8/HIjfAvF/CvFzIPZjBBIvGRgYxBhQwSwgvseAH4gAcTEQMyKJvWLAYtMJIGYgEs9G18+ExeabDMSD++gCjGCTUcFfIC4D4scEDBMC4j4g5iJkIEUA5uUOaOBSgqcjG0h1F44aOGrgqIGjBo4aSGXAAqUFgFiJQrP4aFpJ4QPfgXgLEN8mzkj87ZW/QGwGbSWwAvEhQm0cQi4EtXtOQdm/gXg7MV6+gUdeAojNoWxWIPYmYN4VUKRYAhlzoZpxheE+INYAYmU8hoFaa0kAAQYABLTH1oxy7GAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tel.png
// module id = 0fJc
// module chunks = 1